import React from 'react';
import { 
  FaceFeatures, 
  DOT_COLOR_HEX,
  getEyeSVG, 
  getMouthSVG, 
  getHairSVG, 
  getFacialHairSVG 
} from '../utils/faceGenerator';

interface PlayerFaceProps {
  face?: FaceFeatures;
  size?: number;
}

const PlayerFace: React.FC<PlayerFaceProps> = ({ face, size = 80 }) => {
  if (!face) {
    // Default face if none provided
    return (
      <svg width={size} height={size} viewBox="-30 -40 60 80">
        <circle cx="0" cy="0" r="25" fill="#3b82f6" />
        <circle cx="-8" cy="-2" r="4" fill="white" />
        <circle cx="8" cy="-2" r="4" fill="white" />
        <circle cx="-8" cy="-2" r="2" fill="black" />
        <circle cx="8" cy="-2" r="2" fill="black" />
        <path d="M-10 8 Q0 15 10 8" fill="none" stroke="white" strokeWidth="2" />
      </svg>
    );
  }

  const bgColor = DOT_COLOR_HEX[face.bgColor as keyof typeof DOT_COLOR_HEX] || '#3b82f6';
  const eyeColor = DOT_COLOR_HEX[face.eyeColor as keyof typeof DOT_COLOR_HEX] || '#ffffff';
  const mouthColor = DOT_COLOR_HEX[face.mouthColor as keyof typeof DOT_COLOR_HEX] || '#ffffff';
  const hairColor = DOT_COLOR_HEX[face.hairColor as keyof typeof DOT_COLOR_HEX] || '#1a1a1a';
  const fhColor = DOT_COLOR_HEX[face.facialHairColor as keyof typeof DOT_COLOR_HEX] || '#1a1a1a';

  return (
    <svg width={size} height={size} viewBox="-30 -40 60 80">
      {/* Background circle */}
      <circle cx="0" cy="0" r="25" fill={bgColor} stroke="#000" strokeWidth="1" />
      
      {/* Hair (behind head) */}
      {face.hairStyle !== 'none' && (
        <g color={hairColor}>
          <g dangerouslySetInnerHTML={{ __html: getHairSVG(face.hairStyle as any) }} />
        </g>
      )}
      
      {/* Eyes */}
      <g fill={eyeColor}>
        <g dangerouslySetInnerHTML={{ __html: getEyeSVG(face.eyeStyle as any, face.eyeSize) }} />
      </g>
      
      {/* Mouth */}
      <g fill={mouthColor} stroke={mouthColor}>
        <g dangerouslySetInnerHTML={{ __html: getMouthSVG(face.mouthStyle as any) }} />
      </g>
      
      {/* Facial hair */}
      {face.facialHairStyle !== 'none' && (
        <g fill={fhColor}>
          <g dangerouslySetInnerHTML={{ __html: getFacialHairSVG(face.facialHairStyle as any) }} />
        </g>
      )}
    </svg>
  );
};

export default PlayerFace;
